import React from 'react'
import { Link } from 'react-router-dom';
import {MdKeyboardArrowRight} from '../../assets/icons/icons';
import edukryt from '../../assets/images/logo.png';
import blurb from '../../assets/images/blurb.png';
import { useSelector } from 'react-redux';
import logo_light from '../../assets/images/partholight.png';

import {
    FaFacebookF,
    FaLinkedin,
    FaInstagram,
    FaTwitter
    } from "react-icons/fa";


export default function Footer() {

    const footerData = useSelector((state) => state.websiteReducer.data.data);

    return (
    <footer className="footer bg-dark-footer relative text-gray-200 dark:text-gray-200">
        <div className="container relative">
            <div className="grid grid-cols-12">
                <div className="col-span-12">
                    <div className="py-[60px] px-0">
                        <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                            <div className="lg:col-span-4 md:col-span-12">
                                <Link to="/#" className="text-[22px] focus:outline-none">
                                    <img src={logo_light ? logo_light : ''} alt="footer_logo" className='width50'/>
                                    <div className="md:text-start text-center mt-2">
                                        <p className="mb-0 " style={{fontSize:'16px'}}>© {new Date().getFullYear()} {footerData ? footerData.site_footer_text : ''}</p>
                                    </div>
                                </Link>


                            </div>

                           

                            <div className="lg:col-span-4 md:col-span-4">
                                <h5 className="tracking-[1px] text-gray-100 font-semibold ms-2">Useful Links</h5>
                                <ul className="list-none footer-list mt-6">
                                        {/* <li><Link to='' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="text-xl me-1  " /> About Us </Link></li>
                                        <li><Link to='' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1  "/> Courses</Link></li>
                                        <li><Link to='' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/>Terms & Condition </Link></li>
                                        <li><Link to='' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/> Privacy Policy</Link></li> */}

                                        <li><Link to='/' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="text-xl me-1  " /> About Us </Link></li>
                                        <li><Link to='/contact-one' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1  "/> Contact Us</Link></li>
                                        <li><Link to='/category' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1  "/> Courses</Link></li>
                                        <li><Link to='/page/term-conditions' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/>Terms & Condition </Link></li>
                                        <li><Link to='/page/privacy-policy' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/> Privacy Policy</Link></li>

                                        {/* <li><Link to='/page/refund-policy' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/> Refund Policy</Link></li> */}
                                        

                                        {/* <li><Link to='' className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center mr-1"><MdKeyboardArrowRight className="text-xl me-1"/> Refund Policy</Link></li> */}


                                </ul>
                            </div>

                            <div className="lg:col-span-4 md:col-span-4">
                                <h5 className="tracking-[1px] text-gray-100 font-semibold">Address</h5>
                                <p className="mt-6">PathoElite, Pragati Nagar, Hyderabad - 500090</p>

                                    <div className="grid grid-cols-1">
                                    <div className="my-3 mt-5">
                                                <label className="form-label">
                                                    <a href="mailto: pathoelite@gmail.com">Email id -  pathoelite@gmail.com</a>
                                                </label>

                                                <label className="form-label" >
                                                    <a href="tel:+91-9127510448">Phone / WhatsApp:a - +91-9127510448</a>
                                                </label>

                                            </div>

                                        {/* <div  className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md">Subscribe</div> */}
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       

        <div className="pt-7 px-0 border-t border-slate-800">
            <div className="container relative text-center">
                <div className="grid grid-cols-12">
                <div className="col-span-12">
                    <div className="">
                        <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                            <div className="lg:col-span-6 md:col-span-12">
                                <div className='d-flex align-items-center' style={{diplay:'flex',alightItems:'center'}}>
                                     <div class="text-center md:mt-0 ">
                                        <p class="mb-0 ">Designed by</p>
                                    </div>
                                    <Link to='https://blurb.global/'>
                                        <img src={blurb} alt="logo" className='ms-4' style={{objectFit:'containt',width:'100px'}}/>                                     
                                    </Link>
                                </div>
                            </div>


                            <div className="lg:col-span-6 md:col-span-6 d-flex " style={{flexFlow:'column'}}>
                                <div className="d-flex justify-end align-items-center">
                                    <Link to='https://edukrypt.com/'>
                                        <img src={edukryt} alt="logo"class='edukryptlogo'/>
                                    </Link>
                                    <div className='d-flex justify-end flex-column ms-4' style={{flexFlow:'column'}}>
                                        <p class="mb-0 text-end " style={{fontSize:'13px'}}>Powered by </p><br/>
                                        <p class="mb-0 text-align-end " style={{fontSize:'13px',position:'relative',top:'-20px'}}>Secure Video Encryption With LMS<br/> </p>
                                    </div>
                                    
                                  
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </footer>
    )
}
